import * as yup from 'yup';
import { ROOM_STATUS } from 'constants/index';
import { Room } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape } from 'endpoints/validation';

export type GetParams = {
  status: ROOM_STATUS[];
};
export type GetResult = { rooms: Room.RoomRow[] };
export type GetError = EndpointError;

export const getRoomsParamsSchema = yup.object().shape({
  status: yup.array(yup.string()),
} as unknown as ValidationShape<GetParams>);

export const getRooms = endpoint<GetParams, GetResult, GetError>({
  method: 'GET',
  url: () => '/room/get-rooms',
});
